import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { APP_CONST } from "../config/const";
import { Button, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Whatsapp from "../assets/images/icons/whatsapp.png";
import ModalWrapper from "./ModalWrapper";
import Logo from "../assets/images/logo.png";
import AviatorLogo from "../assets/images/icons/aviator-icon.webp";
import RegistrationIcon from "../assets/images/icons/registration-icon.webp";
import ArrowRight from "../assets/images/icons/arrow-right.webp";
import GiftIcon from "../assets/images/icons/gift-icon.webp";
import Bonuses from "../assets/images/icons/bonuses.webp";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { useTranslation } from "react-i18next";

const headerPages = [
  "home",
  "betby",
  "sports1",
  "casinogames",
  "livecasino",
  "aviator",
  "evolution",
  "ezugi",
  "supernowa",
  "vivo",
  "xpg",
  "worldcasino",
  "qtech",
  "atlas-lobby",
  "/",
  "spmsports",
];

const Header = () => {
  const { appDetails } = useSelector((state) => state.app);
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState("login");
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const { t } = useTranslation();

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };

  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (currentScrollTop > lastScrollTop && currentScrollTop > 0) {
        // Scrolling down
        setIsSticky(true);
      } else if (currentScrollTop <= 0) {
        // Remove sticky class when scrolled all the way up
        setIsSticky(false);
      }
      setLastScrollTop(currentScrollTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const [isproviderActive, setIsproviderActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const inlineStyle = isproviderActive ? { overflowX: "clip" } : {};
  const handleProvidersClick = () => {
    const isMobile = window.innerWidth < 992;

    if (isMobile) {
      setShowModal(true);
      document.body.classList.add("modal-providers");
      document.documentElement.style.overflow = "hidden";
    } else {
      setIsproviderActive(!isproviderActive);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    document.body.classList.remove("modal-providers");
    document.documentElement.style.overflow = "auto";
  };

  const menuItems = [
    { name: t("home"), path: "/", activeKey: "/" },
    // {
    //   name: "Sports",
    //   path: "/atlas-lobby",
    //   activeKey: "betby",
    // },
    { name: "Exchange", path: "/sports/Inplay", activeKey: "sports1" },
    // { name: "Exchange 2", path: "/spmsports", activeKey: "spmsports" },
    { name: "Sport", path: "/exchange/ig_pixel", activeKey: "igpixel" },

    { name: t("slots"), path: "/casinogames", activeKey: "casinogames" },

    { name: t("live_casino"), path: "/livecasino", activeKey: "livecasino" },
    {
      name: t("aviator"),
      path: "casino/spribe/aviator",
      activeKey: "aviator",
      isLogo: true,
      logo: AviatorLogo,
    },

    {
      name: "ALT Gaming",
      path: "/gap",
      activeKey: "gap",
    },
  ];
  const providers = [
    { name: t("evolution"), path: "/casino/evolution", activeKey: "evolution" },
    { name: t("ezugi"), path: "/casino/ezugi", activeKey: "ezugi" },
    { name: t("supernowa"), path: "/casino/supernowa", activeKey: "supernowa" },
    { name: t("vivo"), path: "/casino/vivo", activeKey: "vivo" },
    // { name: "XPG", path: "/casino/xpg", activeKey: "xpg" },
    // {
    //   name: "Worldcasino",
    //   path: "/casino/worldcasino",
    //   activeKey: "worldcasino",
    // },
    { name: t("qtech"), path: "/casino/qtech", activeKey: "qtech" },
    { name: t("aura"), path: "/aura-games", activeKey: "aura" },
    { name: "ALT Gaming", path: "/gap", activeKey: "gap" },

    { name: "Vimplay", path: "/vimplay", activeKey: "vimplay" },
  ];

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header beforeheader">
        <div className="top_head d-none d-lg-block">
          <div className="inner-box">
            <div className="left-section">
              {/* <a href="/promotions" className="vip-level">
                <span>Welcome Bonus</span>
                <span className="vip-icon"></span>
                <img src={ArrowRight} alt="right arrow" />
              </a> */}
              <div style={{ backgroundImage: "none" }} className="vip-level">
                <span></span>
              </div>
              <div className="vip-gift">
                <div className="vip-icon">
                  <a
                    className="whatsIcon"
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "#"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <div className="img-box">
                      <img src={Whatsapp} alt="whatsapp" />
                    </div>
                  </a>
                  <span className="vip-icon1"></span>
                  <span className="vip-icon2"></span>
                  <span className="dot1"></span>
                  <span className="dot2"></span>
                </div>
              </div>
            </div>{" "}
            <div className="right-section">
              {/* <div>
                <CustomLanguageSelector />
              </div> */}
              <div className="vip-gift">
                <a href="/promotions" className="promotion">
                  <div className="img-box">
                    <img src={GiftIcon} alt="promotions" />
                  </div>
                  <span>{t("promotion_and_bonuses")}</span>
                  <img src={Bonuses} alt="bonuses" className="bonus" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className={`bottom_head ${isSticky ? "sticky" : ""}`}>
          <div className="inner-box">
            <div className="logo">
              <a href="/">
                <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
                {/* <img src={Logo} alt="Logo" /> */}
              </a>
            </div>

            <div className="head-links">
              <ul style={inlineStyle}>
                {menuItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.path}
                      className={`
                      ${
                        location.pathname === item.path ||
                        activePage === item.activeKey
                          ? "active"
                          : ""
                      }
                      ${item.name === "Aviator" ? "game-logo" : ""}
                    `}
                    >
                      <span>
                        {item.isLogo ? (
                          <img src={item.logo} alt={item.name} />
                        ) : (
                          item.name
                        )}
                      </span>
                    </a>
                  </li>
                ))}
                <li className="providers">
                  <a href="javascript:void(0)" onClick={handleProvidersClick}>
                    <span>{t("games_by_provider")}</span>
                  </a>
                  <ul
                    className={`providers-games d-none d-md-flex ${
                      isproviderActive ? "active" : ""
                    }`}
                  >
                    {providers.map((provider) => (
                      <li key={provider.name}>
                        <a
                          href={provider.path}
                          className={
                            activePage === provider.activeKey ? "active" : ""
                          }
                        >
                          <span>{provider.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>

                {/* <li className="providers">
                <a
                  href="/atlas-lobby"
                  className={activePage === "atlas-lobby" ? "active" : ""}
                >
                  <span>Sportsbook 2</span>
                </a>
              </li> */}
              </ul>

              <div className="d-lg-none">
                <GamesSearchModal />
              </div>
            </div>

            <div className="rightSec ms-lg-auto">
              <Button
                variant=""
                onClick={() => {
                  handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                }}
                className="btn_signin"
              >
                {t("login")}
              </Button>
              <Button
                variant=""
                onClick={() => {
                  handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                }}
                className="btn_signup"
              >
                <span className="d-none d-lg-inline-flex">
                  <img src={RegistrationIcon} alt="registration" />
                </span>
                {t("register")}
              </Button>
            </div>
          </div>
        </div>

        <Modal
          className="providers-list"
          show={showModal}
          onHide={handleModalClose}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Body>
            <div className="providers-link">
              <ul>
                {providers.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.path}
                      className={
                        activePage === provider.activeKey ? "active" : ""
                      }
                    >
                      <span>{provider.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Modal.Body>
        </Modal>

        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
          />
        )}
      </header>
    </>
  );
};

export default Header;
